import clsx from "clsx";
import { FormikProps } from 'formik';
import { useEffect, useState } from 'react';
import MaskedInput from 'react-text-mask';
import Swal from 'sweetalert2';
import { IEmpresas } from '../../interfaces/IEmpresas';
import { IMunicipioIBGE } from '../../interfaces/IMunicipioIBGE';
import EmpresasService from '../../services/EmpresasService';
import IBGEService from '../../services/IBGEService';
import { LISTA_ESTADOS, MASCARA_CEP, MASCARA_CNPJ, MASCARA_DATA, MASCARA_TELEFONE } from '../../utils/Constants';
import '../importar/styleGlobal.css';

/*Tradução */
import './../../../i18n/config';
import { useTranslation } from 'react-i18next';

const EmpresasNovoModal = ({ empresa, formikEmpresa: formik, abaSelecionada }: { empresa: IEmpresas | null, formikEmpresa: FormikProps<IEmpresas>, abaSelecionada: string }) => {

    const [municipios, setMunicipios] = useState<IMunicipioIBGE[]>([]);
    const [urlFile, setUrlFile] = useState<string>();
    const [logoPropria, setLogoPropria] = useState<boolean>(false);
    const [loadingFile, setLoadingFile] = useState<boolean>(false);
    const { t } = useTranslation();

    const urlLogoPadrao = (clienteID?: number) => `https://ecd-files.s3.us-east-2.amazonaws.com/${clienteID}.png`;

    useEffect(() => {
        async function preCarregar() {
            formik.resetForm();

            if (empresa !== null) {
                const empresaEntries = Object.entries(empresa)

                for (const [key, value] of empresaEntries) {
                    formik.setFieldValue(key, value || '');
                }

                if (empresa.id) {
                    try {
                        const logo = await EmpresasService.obterLogo(empresa.id);
                        setLogoPropria(!!logo);
                        setUrlFile(logo ?? urlLogoPadrao(empresa.clienteID));
                    } catch {
                        setLogoPropria(false);
                        setUrlFile(urlLogoPadrao(empresa.clienteID));
                    }
                } else {
                    setLogoPropria(false);
                    setUrlFile(urlLogoPadrao(empresa.clienteID));
                }

                await IBGEService.pesquisarMunicipios(empresa.estado ?? "", x => setMunicipios(x));
            }
        };

        preCarregar();

        // eslint-disable-next-line
    }, [empresa])

    const onChangeFile = async (e: any) => {
        if (!empresa?.id || e.target.files === null || e.target.files.length === 0) return;

        setLoadingFile(true);
        try {
            const file = e.target.files[0] as File;
            const url = await EmpresasService.enviarLogo(empresa.id, file);
            setUrlFile(url);
            setLogoPropria(true);
        } catch {
            Swal.fire({
                text: t('Não foi possível enviar a logo. Verifique o formato (PNG, JPG ou WEBP) e o tamanho (máx. 5MB).'),
                timer: 4000,
                icon: 'error',
                showConfirmButton: false
            });
        } finally {
            setLoadingFile(false);
            e.target.value = '';
        }
    }

    const onRemoverLogo = async () => {
        if (!empresa?.id) return;

        setLoadingFile(true);
        try {
            await EmpresasService.removerLogo(empresa.id);
            setUrlFile(urlLogoPadrao(empresa.clienteID));
            setLogoPropria(false);
        } catch {
            Swal.fire({
                text: t('Não foi possível remover a logo.'),
                timer: 4000,
                icon: 'error',
                showConfirmButton: false
            });
        } finally {
            setLoadingFile(false);
        }
    }

    return <>
        <div className="col-md-12" style={{ display: abaSelecionada === '1' ? 'flex' : 'none', border: '1px solid #ddd', borderRadius: '5px', padding: '10px' }}>
            <div className="col-md-6" style={{ borderRight: '1px solid #ddd', margin: '0 10px', padding: '0 10px' }}>
                <div className='col-md-12' style={{ marginBottom: '10px' }}>
                    {!loadingFile ? <>
                        <div className='col-md-12'>
                            <label className="form-label">{t('Logo Empresa (PNG, JPG ou WEBP)')}</label>
                        </div>
                        <div className='col-md-12' style={{ marginBottom: '10px', display: 'flex', alignItems: 'center', gap: '10px' }}>
                            {urlFile ? <img src={urlFile} alt="Preview" style={{ width: '50px', height: '50px' }} /> : null}
                            {logoPropria && empresa?.id ? (
                                <button type="button" className="btn btn-sm btn-modal-cancelar" onClick={onRemoverLogo}>
                                    {t('Remover logo')}
                                </button>
                            ) : null}
                        </div>
                        {empresa?.id ? <>
                            <div className='col-md-12'>
                                <input type='file' placeholder={t('Insira a imagem aqui')} accept='image/png,image/jpeg,image/webp' onChange={(e) => onChangeFile(e)} />
                            </div>
                            <div className='col-md-12'>
                                <p style={{ fontSize: '12px', fontStyle: 'italic', fontWeight: 'bold', color: 'red' }}>{t('não precisa salvar a empresa, ao inserir a imagem já fica salva.')}</p>
                            </div>
                        </> : (
                            <div className='col-md-12'>
                                <p style={{ fontSize: '12px', fontStyle: 'italic' }}>{t('Salve a empresa antes de enviar a logo.')}</p>
                            </div>
                        )}
                    </> :
                        <div className='col-md-12'>
                            <p>{t('(Carregando...')}</p>
                        </div>
                    }
                </div>
                <div style={{ display: 'flex' }}>
                    <div className="col-md-8 importarNovoModal">
                        <label htmlFor="form-obrigacao-nome" className="form-label required">{t('CNPJ')}</label>
                        <MaskedInput disabled mask={MASCARA_CNPJ} {...formik.getFieldProps('cnpj')} placeholder="00.000.000/0000-00" type="text" className={clsx(
                            'form-control',
                            {
                                'is-invalid': formik.touched.cnpj && formik.errors.cnpj,
                            },
                            {
                                'is-valid': formik.touched.cnpj && !formik.errors.cnpj,
                            }
                        )} id="form-cnpj" />
                    </div>
                    <div className="col-md-4">
                        <label htmlFor="form-obrigacao-nome" className="form-label required">{t('Data de Abertura')}</label>
                        <MaskedInput disabled mask={MASCARA_DATA} {...formik.getFieldProps('dataAberturaString')} placeholder="00/00/0000" type="text" className={clsx(
                            'form-control',
                            {
                                'is-invalid': formik.touched.dataAberturaString && formik.errors.dataAberturaString,
                            },
                            {
                                'is-valid': formik.touched.dataAberturaString && !formik.errors.dataAberturaString,
                            }
                        )} id="form-dataAbertura" />
                    </div>
                </div>
                <div className="col-md-12">
                    <label htmlFor="form-obrigacao-nome" className="form-label required">{t('Razão Social')}</label>
                    <input disabled {...formik.getFieldProps('razaoSocial')} placeholder={t('Digite algo')} type="text" className={clsx(
                        'form-control',
                        {
                            'is-invalid': formik.touched.razaoSocial && formik.errors.razaoSocial,
                        },
                        {
                            'is-valid': formik.touched.razaoSocial && !formik.errors.razaoSocial,
                        }
                    )} id="form-razaoSocial" />
                </div>
                <div style={{ display: 'flex' }}>
                    <div className="col-md-9 importarNovoModal">
                        <label htmlFor="form-obrigacao-nome" className="form-label required">{t('Nome Fantasia')}</label>
                        <input disabled {...formik.getFieldProps('nomeFantasia')} placeholder={t('Digite algo')} type="text" className={clsx(
                            'form-control',
                            {
                                'is-invalid': formik.touched.nomeFantasia && formik.errors.nomeFantasia,
                            },
                            {
                                'is-valid': formik.touched.nomeFantasia && !formik.errors.nomeFantasia,
                            }
                        )} id="form-nomeFantasia" />
                    </div>
                    <div className="col-md-3">
                        <label htmlFor="form-obrigacao-nome" className="form-label required">{t('Porte')}</label>
                        <input disabled {...formik.getFieldProps('porte')} placeholder={t('Digite algo')} type="text" className={clsx(
                            'form-control',
                            {
                                'is-invalid': formik.touched.porte && formik.errors.porte,
                            },
                            {
                                'is-valid': formik.touched.porte && !formik.errors.porte,
                            }
                        )} id="form-porte" />
                    </div>
                </div>
                <div className="col-md-12">
                    <label htmlFor="form-obrigacao-nome" className="form-label required">{t('Código e Descrição da Atividade Principal')}</label>
                    <input disabled {...formik.getFieldProps('atividadePrincipal')} placeholder={t('Digite algo')} type="text" className={clsx(
                        'form-control',
                        {
                            'is-invalid': formik.touched.atividadePrincipal && formik.errors.atividadePrincipal,
                        },
                        {
                            'is-valid': formik.touched.atividadePrincipal && !formik.errors.atividadePrincipal,
                        }
                    )} id="form-atividadePrincipal" />
                </div>
                <div className="col-md-12">
                    <label htmlFor="form-obrigacao-nome" className="form-label required">{t('Código e Descrição da Atividade Secundária')}</label>
                    <input disabled {...formik.getFieldProps('atividadeSecundaria')} placeholder={t('Digite algo')} type="text" className={clsx(
                        'form-control',
                        {
                            'is-invalid': formik.touched.atividadeSecundaria && formik.errors.atividadeSecundaria,
                        },
                        {
                            'is-valid': formik.touched.atividadeSecundaria && !formik.errors.atividadeSecundaria,
                        }
                    )} id="form-atividadeSecundaria" />
                </div>
                <div style={{ display: 'flex' }}>
                    <div className="col-md-9 importarNovoModal">
                        <label htmlFor="form-obrigacao-nome" className="form-label required">{t('Endereço')}</label>
                        <input disabled {...formik.getFieldProps('endereco')} placeholder={t('Digite algo')} type="text" className={clsx(
                            'form-control',
                            {
                                'is-invalid': formik.touched.endereco && formik.errors.endereco,
                            },
                            {
                                'is-valid': formik.touched.endereco && !formik.errors.endereco,
                            }
                        )} id="form-endereco" />
                    </div>
                    <div className="col-md-3">
                        <label htmlFor="form-obrigacao-nome" className="form-label required">{t('Número')}</label>
                        <input disabled {...formik.getFieldProps('numero')} placeholder={t('Digite algo')} type="text" className={clsx(
                            'form-control',
                            {
                                'is-invalid': formik.touched.numero && formik.errors.numero,
                            },
                            {
                                'is-valid': formik.touched.numero && !formik.errors.numero,
                            }
                        )} id="form-numero" />
                    </div>
                </div>
                <div style={{ display: 'flex' }}>
                    <div className="col-md-9 importarNovoModal">
                        <label htmlFor="form-obrigacao-nome" className="form-label required">{t('Complemento')}</label>
                        <input disabled {...formik.getFieldProps('complemento')} placeholder={t('Digite algo')} type="text" className={clsx(
                            'form-control',
                            {
                                'is-invalid': formik.touched.complemento && formik.errors.complemento,
                            },
                            {
                                'is-valid': formik.touched.complemento && !formik.errors.complemento,
                            }
                        )} id="form-complemento" />
                    </div>
                    <div className="col-md-3">
                        <label htmlFor="form-obrigacao-nome" className="form-label required">{t('CEP')}</label>
                        <MaskedInput disabled mask={MASCARA_CEP} {...formik.getFieldProps('cep')} placeholder="00000-000" type="text" className={clsx(
                            'form-control',
                            {
                                'is-invalid': formik.touched.cep && formik.errors.cep,
                            },
                            {
                                'is-valid': formik.touched.cep && !formik.errors.cep,
                            }
                        )} id="form-cep" />
                    </div>
                </div>
            </div>

            <div className="col-md-6">
                <div style={{ display: 'flex' }}>
                    <div className="col-md-5 importarNovoModal">
                        <label htmlFor="form-obrigacao-nome" className="form-label required">{t('Bairro')}</label>
                        <input disabled {...formik.getFieldProps('bairro')} placeholder={t('Digite algo')} type="text" className={clsx(
                            'form-control',
                            {
                                'is-invalid': formik.touched.bairro && formik.errors.bairro,
                            },
                            {
                                'is-valid': formik.touched.bairro && !formik.errors.bairro,
                            }
                        )} id="form-bairro" />
                    </div>
                    <div className="col-md-4 importarNovoModal">
                        <label htmlFor="form-obrigacao-nome" className="form-label required">{t('Município')}</label>
                        <select disabled {...formik.getFieldProps('municipio')} className={clsx(
                            'form-select',
                            {
                                'is-invalid': formik.touched.municipio && formik.errors.municipio,
                            },
                            {
                                'is-valid': formik.touched.municipio && !formik.errors.municipio,
                            }
                        )} id="form-municipio" >
                            <option value="" hidden>{t('Selecione')}</option>
                            {
                                municipios.map((x, index) => <option key={index} value={x.nome}>{x.nome}</option>)
                            }
                        </select>
                    </div>
                    <div className="col-md-2">
                        <label htmlFor="form-mensagem-tipo" className="form-label required">{t('UF')}</label>
                        <select disabled {...formik.getFieldProps('estado')} className={clsx(
                            'form-select',
                            {
                                'is-invalid': formik.touched.estado && formik.errors.estado
                            },
                            {
                                'is-valid': formik.touched.estado && !formik.errors.estado
                            }
                        )} id="form-estado" onChange={async e => {
                            await formik.setFieldValue('estado', e.target.value);
                            if (e.target.value) {
                                await IBGEService.pesquisarMunicipios(e.target.value, x => setMunicipios(x));
                            }
                        }}>
                            <option value="" hidden>UF</option>
                            {
                                LISTA_ESTADOS.map((x, index) => <option key={index}>{x}</option>)
                            }
                        </select>
                    </div>
                </div>
                <div className="col-md-11">
                    <label htmlFor="form-obrigacao-nome" className="form-label required">{t('E-mail')}</label>
                    <input disabled {...formik.getFieldProps('email')} placeholder="example@exemple.com" type="text" className={clsx(
                        'form-control',
                        {
                            'is-invalid': formik.touched.email && formik.errors.email,
                        },
                        {
                            'is-valid': formik.touched.email && !formik.errors.email,
                        }
                    )} id="form-email" />
                </div>
                <div style={{ display: 'flex' }}>
                    <div className="col-md-6 importarNovoModal">
                        <label htmlFor="form-obrigacao-nome" className="form-label required">{t('Telefone')}</label>
                        <MaskedInput disabled mask={MASCARA_TELEFONE} {...formik.getFieldProps('telefone')} placeholder="(00)0000-0000" type="text" className={clsx(
                            'form-control',
                            {
                                'is-invalid': formik.touched.telefone && formik.errors.telefone,
                            },
                            {
                                'is-valid': formik.touched.telefone && !formik.errors.telefone,
                            }
                        )} id="form-telefone" />
                    </div>
                    <div className="col-md-5">
                        <label htmlFor="form-obrigacao-nome" className="form-label required">{t('Telefone Adicional')}</label>
                        <MaskedInput disabled mask={MASCARA_TELEFONE} {...formik.getFieldProps('telefoneAdicional')} placeholder="(00)0000-0000" type="text" className={clsx(
                            'form-control',
                            {
                                'is-invalid': formik.touched.telefoneAdicional && formik.errors.telefoneAdicional,
                            },
                            {
                                'is-valid': formik.touched.telefoneAdicional && !formik.errors.telefoneAdicional,
                            }
                        )} id="form-telAdcional" />
                    </div>
                </div>
                <div style={{ display: 'flex' }}>
                    <div className="col-md-8 importarNovoModal">
                        <label htmlFor="form-obrigacao-nome" className="form-label required">{t('Situação Cadastral')}</label>
                        <input disabled {...formik.getFieldProps('situacaoCadastral')} placeholder={t('Digite algo')} type="text" className={clsx(
                            'form-control',
                            {
                                'is-invalid': formik.touched.situacaoCadastral && formik.errors.situacaoCadastral,
                            },
                            {
                                'is-valid': formik.touched.situacaoCadastral && !formik.errors.situacaoCadastral,
                            }
                        )} id="form-situacaoCadastral" />
                    </div>
                    <div className="col-md-3">
                        <label htmlFor="form-obrigacao-nome" className="form-label required">{t('Data da Situação Cad.')}</label>
                        <MaskedInput mask={MASCARA_DATA} {...formik.getFieldProps('dataSituacaoCadastralString')} placeholder="00/00/0000" type="text" className={clsx(
                            'form-control',
                            {
                                'is-invalid': formik.touched.dataSituacaoCadastralString && formik.errors.dataSituacaoCadastralString,
                            },
                            {
                                'is-valid': formik.touched.dataSituacaoCadastralString && !formik.errors.dataSituacaoCadastralString,
                            }
                        )} id="form-dataSituacao" />
                    </div>
                </div>
                <div className="col-md-11">
                    <label htmlFor="form-obrigacao-nome" className="form-label required">{t('Motivo da Situação Cadastral')}</label>
                    <input disabled {...formik.getFieldProps('motivoSituacaoCadastral')} placeholder={t('Digite algo')} type="text" className={clsx(
                        'form-control',
                        {
                            'is-invalid': formik.touched.motivoSituacaoCadastral && formik.errors.motivoSituacaoCadastral,
                        },
                        {
                            'is-valid': formik.touched.motivoSituacaoCadastral && !formik.errors.motivoSituacaoCadastral,
                        }
                    )} id="form-motivoSituacao" />
                </div>
                <div style={{ display: 'flex' }}>
                    <div className="col-md-8 importarNovoModal">
                        <label htmlFor="form-obrigacao-nome" className="form-label required">{t('Situação Especial')}</label>
                        <input disabled {...formik.getFieldProps('situacaoEspecial')} placeholder={t('Digite algo')} type="text" className={clsx(
                            'form-control',
                            {
                                'is-invalid': formik.touched.situacaoEspecial && formik.errors.situacaoEspecial,
                            },
                            {
                                'is-valid': formik.touched.situacaoEspecial && !formik.errors.situacaoEspecial,
                            }
                        )} id="form-SsituacaoEsp" />
                    </div>
                    <div className="col-md-3">
                        <label htmlFor="form-obrigacao-nome" className="form-label required">{t('Data da Situação Esp.')}</label>
                        <MaskedInput disabled mask={MASCARA_DATA} {...formik.getFieldProps('dataSituacaoEspecialString')} placeholder="00000-000" type="text" className={clsx(
                            'form-control',
                            {
                                'is-invalid': formik.touched.dataSituacaoEspecialString && formik.errors.dataSituacaoEspecialString,
                            },
                            {
                                'is-valid': formik.touched.dataSituacaoEspecialString && !formik.errors.dataSituacaoEspecialString,
                            }
                        )} id="form-dataSituacao" />
                    </div>
                </div>
                <div style={{ display: 'flex', marginTop: '15px' }}>
                    <div className="col-md-4">
                        <label htmlFor="form-tipoSistema" className="form-label required">{t('Sistema Utilizado')}</label>
                        <select {...formik.getFieldProps('tipoSistema')} className={clsx(
                            'form-select',
                            {
                                'is-invalid': formik.touched.tipoSistema && formik.errors.tipoSistema,
                            },
                            {
                                'is-valid': formik.touched.tipoSistema && !formik.errors.tipoSistema,
                            }
                        )} id="form-tipoSistema" >
                            <option value="" hidden>{t('Selecione')}</option>
                            <option value="dominio">{t('Domínio')}</option>
                            <option value="sage">{t('Sage')}</option>
                            <option value="questor">{t('Questor')}</option>
                            <option value="sci">{t('SCI')}</option>
                            <option value="wkradar">{t('Radar')}</option>
                            <option value="fortes">{t('Fortes')}</option>
                            <option value="contimatic">{t('Contimatic')}</option>
                        </select>
                    </div>
                    <div className="col-md-4" style={{ width: '100%', marginTop: '36px', marginLeft: '6px', flexDirection: 'column', alignContent: 'center', justifyContent: 'center' }}>
                        <label className='form-check-label fw-bold'>
                            {t('Um fornecedor/cliente por conta')}
                        </label>
                        <input
                            {...formik.getFieldProps('umaContaPorFornecedor')}
                            checked={formik.values['umaContaPorFornecedor']}
                            style={{ marginLeft: '15px' }}
                            className='form-check-input'
                            type='checkbox'
                        />
                    </div>
                </div>
            </div>
        </div>
    </>
}

export default EmpresasNovoModal;